import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "apps" }
const _hoisted_3 = { class: "app-icon ion-padding" }
const _hoisted_4 = ["src"]

import { IonAvatar, IonButton, IonCard, IonCardHeader, IonCardTitle, IonContent, IonIcon, IonItem, IonLabel, IonList, IonPage, onIonViewDidEnter, popoverController } from '@ionic/vue';
import { chevronForwardOutline, hardwareChipOutline, openOutline, personCircleOutline, rocketOutline } from 'ionicons/icons';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/store/auth';
import { goToOms } from '@hotwax/dxp-components';
import { appInfo } from '@/util';
import UserActionsPopover from '@/components/UserActionsPopover.vue';
import Image from '@/components/Image.vue';
import { Actions, hasPermission, setPermissions } from '@/authorization';

const scheme = 'https://';
const domain = '.socwms.com';


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const authStore = useAuthStore();
const router = useRouter();

const appCategory = appInfo.reduce((obj: Record<string, any[]>, app: any) => {
  if (obj[app.type]) {
    obj[app.type].push(app);
  } else {
    obj[app.type] = [app];
  }

  return obj;
}, {});

onIonViewDidEnter(() => {
  // clearing the redirect URL to break the login and redirection flow
  // if the user navigates to the home page while login
  authStore.setRedirectUrl('');
  setPermissions(authStore.permissions);
});

const generateAppLink = (app: any) => {
  const appEnvironment = process.env.VUE_APP_HANDLE_TYPE;
  const domain = process.env.VUE_APP_DOMAIN
  const handle = app.handle;
  const oms = authStore.getOMS;
  window.location.href = "https://" + handle + appEnvironment + domain + (authStore.isAuthenticated ? `/login?oms=${oms.startsWith("http") ? oms.includes("/api") ? oms : `${oms}/api/` : oms}&token=${authStore.token.value}&expirationTime=${authStore.token.expiration}`: "");
};

const openUserActionsPopover = async (event: any) => {
  const userActionsPopover = await popoverController.create({
    component: UserActionsPopover,
    event,
    showBackdrop: false,
  });

  userActionsPopover.present();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("header", null, [
            _createElementVNode("h1", _hoisted_1, [
              _createTextVNode(_toDisplayString(_ctx.$t('Launch Pad')) + " ", 1),
              _createVNode(_unref(IonIcon), {
                color: "danger",
                icon: _unref(rocketOutline)
              }, null, 8, ["icon"])
            ]),
            (_unref(authStore).isAuthenticated)
              ? (_openBlock(), _createBlock(_unref(IonCard), { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonList), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonItem), {
                          lines: _unref(hasPermission)(_unref(Actions).APP_COMMERCE_VIEW) ? 'full' : 'none',
                          button: "",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (openUserActionsPopover($event)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonAvatar), { slot: "start" }, {
                              default: _withCtx(() => [
                                _createVNode(Image, {
                                  src: _unref(authStore).current?.partyImageUrl
                                }, null, 8, ["src"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonLabel), { class: "ion-text-nowrap" }, {
                              default: _withCtx(() => [
                                _createElementVNode("h2", null, _toDisplayString(_unref(authStore).current?.partyName ? _unref(authStore).current?.partyName : _unref(authStore).current.userLoginId), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonIcon), {
                              slot: "end",
                              icon: _unref(chevronForwardOutline),
                              class: "ion-margin-start"
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }, 8, ["lines"]),
                        (_unref(hasPermission)(_unref(Actions).APP_COMMERCE_VIEW))
                          ? (_openBlock(), _createBlock(_unref(IonItem), {
                              key: 0,
                              lines: "none",
                              button: "",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(goToOms)(_unref(authStore).token.value, _unref(authStore).getOMS)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonIcon), {
                                  slot: "start",
                                  icon: _unref(hardwareChipOutline)
                                }, null, 8, ["icon"]),
                                _createVNode(_unref(IonLabel), null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("h2", null, _toDisplayString(_unref(authStore).getOMS), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(IonIcon), {
                                  slot: "end",
                                  icon: _unref(openOutline),
                                  class: "ion-margin-start"
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_unref(IonButton), {
                  key: 1,
                  fill: "outline",
                  color: "danger",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/login')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      slot: "start",
                      icon: _unref(personCircleOutline)
                    }, null, 8, ["icon"]),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('Login')), 1)
                  ]),
                  _: 1
                }))
          ]),
          _createElementVNode("main", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_unref(appCategory)), (category) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "type",
                key: category
              }, [
                _createElementVNode("h3", null, _toDisplayString(category), 1),
                _createElementVNode("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appCategory)[category], (app) => {
                    return (_openBlock(), _createBlock(_unref(IonCard), {
                      button: "",
                      class: "app",
                      key: app.handle,
                      onClick: _withModifiers(($event: any) => (generateAppLink(app)), ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("img", {
                            src: app.resource
                          }, null, 8, _hoisted_4)
                        ]),
                        _createVNode(_unref(IonCardHeader), { class: "app-content" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonCardTitle), { color: "text-medium" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(app.name), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})